import React from "react";
import MaterialTypeDropdown from "../shared/MaterialTypeDropdown";
import SizeDropdown from "../shared/SizeDropdown";
import InputField from "../generic/InputField";
import QuantityUnitDropdown from "../shared/QuantityUnitDropdown";
import RowItem from "../generic/RowItem";

interface MaterialRowProps {
    row: {
        material_type_id: number | null;
        material_size_id: number | null;
        quantity: string;
        quantity_unit?: string | null;
    };
    index: number;
    onChange: <K extends keyof MaterialRowProps["row"]>(
        index: number,
        field: K,
        value: MaterialRowProps["row"][K],
    ) => void;
    onRemove: (index: number) => void;
    showRemoveButton: boolean;
}

const MaterialRow: React.FC<MaterialRowProps> = ({
                                                     row,
                                                     index,
                                                     onChange,
                                                     onRemove,
                                                     showRemoveButton,
                                                 }) => {
    const handleQuantityChange = (value: string) => {
        // Allow only numbers and at most one decimal point
        const decimalRegex = /^\d*\.?\d*$/;
        if (decimalRegex.test(value)) {
            onChange(index, "quantity", value);
        }
    };

    const handleQuantityUnitChange = (value: string | null) => {
        onChange(index, "quantity_unit", value);
    };

    return (
        <RowItem index={index} showRemoveButton={showRemoveButton} onRemove={onRemove}>
            <MaterialTypeDropdown
                value={row.material_type_id}
                onChange={(value) => onChange(index, "material_type_id", value)}
            />
            <SizeDropdown
                selectedSize={row.material_size_id}
                onSelectSize={(value: number | null) => onChange(index, "material_size_id", value)}
            />
            <InputField
                type="number"
                value={row.quantity}
                label="Quantity"
                placeholder="Enter quantity (e.g., 10.5)"
                onChange={(value) => handleQuantityChange(value)}
                required
            />
            <QuantityUnitDropdown
                value={row.quantity_unit || null}
                onChange={handleQuantityUnitChange}
            />
        </RowItem>
    );
};

export default MaterialRow;
